import WarningAmber from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';

import BulletPoint from './BulletPoint';
import { PreviewBlocker } from '../../text';
import CustomWidthTooltip from '../CustomWidthTooltip';

interface ReplanWarningProps {
  title: string;
  previewBlockers: PreviewBlocker[];
}

const ReplanWarning = ({ previewBlockers, title }: ReplanWarningProps) => {
  if (previewBlockers.length === 0) return null;

  return (
    <CustomWidthTooltip
      placement="bottom-end"
      title={
        <Box p={2}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          <List sx={{ listStyleType: 'disc', p: 0 }}>
            {previewBlockers.map((previewBlocker) => (
              <BulletPoint
                key={previewBlocker.title}
                title={previewBlocker.title}
                description={previewBlocker.description}
              />
            ))}
          </List>
        </Box>
      }
    >
      <WarningAmber color="error" titleAccess="replan warnings present" />
    </CustomWidthTooltip>
  );
};

export default ReplanWarning;
